import React, { useState } from 'react'
import styled from 'styled-components'
import { Text } from 'app/components/ui/Text'
import { Title } from 'app/components/ui/Title'
import { Button } from 'app/components/ui/Button'
import { Modal } from 'app/components/ui/Modal'
import { OfferModalForm } from './OfferModalForm'

interface Props {
  onToggle: (isVisible: boolean) => void
  isVisible: boolean
}

export const OfferModal: React.FC<Props> = ({ isVisible, onToggle }) => {
  const [showSuccess, setShowSuccess] = useState(false)

  return (
    <>
      {isVisible && (
        <Modal
          onCloseRequest={() => onToggle(false)}
          title=''
          size='lg'
          hasOuterScroll
        >
          {showSuccess ? (
            <SuccessWrapper>
              <Title size={3}>
                La tua richiesta è stata inviata correttamente
              </Title>
              <Text variant='s20' mt={1.5} mb={2}>
                Ti ricontatteremo al più presto.
              </Text>
              <Button onClick={() => onToggle(false)} variant='nero'>
                Chiudi e torna alla homepage
              </Button>
            </SuccessWrapper>
          ) : (
            <OfferModalForm
              onSubmitSuccess={() => {
                setShowSuccess(true)
              }}
            />
          )}
        </Modal>
      )}
    </>
  )
}

const SuccessWrapper = styled.div`
  text-align: center;
  max-width: 540px;
  margin-right: auto;
  margin-left: auto;
`
